import is from 'is_js';

/**
 * @returns {boolean} True if the current environment supports WebGL, false if not.
 */
const checkWebGL = () => {
  const canvas = document.createElement('canvas');
  // Get WebGLRenderingContext from canvas element.
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  // Report the result.
  if (gl && gl instanceof WebGLRenderingContext) return true;
  return false;
};

/**
 * Generates a report that contains any compatibility issues in the current user environment, and always contains a single boolean value for incompatible.
 * @returns {Object} Object that contains a report of any compatibility issues. Always contains the 'incompatible' key boolean value.
 */
export const createCompatibilityReport = () => {
  let incompatible = false;
  let mobile = false;
  let ios = false;
  let android = false;
  let wrongBrowser = false;
  let oldBrowser = false;
  let noWebgl = false;
  let screenWidthTooLow = false;

  // Mobile?
  if (is.mobile()) {
    incompatible = true;
    mobile = true;

    if (is.ios()) {
      ios = true;
    }

    if (is.android()) {
      android = true;
    }
  }

  // Browser?
  if (!is.chrome() && !is.firefox() && !is.safari() && !is.edge() && !is.opera()) {
    incompatible = true;
    wrongBrowser = true;
  }

  // Browser is ok, now we need to check versions:
  if (is.chrome() && is.chrome('<79')) {
    incompatible = true;
    oldBrowser = true;
  }
  if (is.firefox() && is.firefox('<72')) {
    incompatible = true;
    oldBrowser = true;
  }
  if (is.safari() && is.safari('<12')) {
    incompatible = true;
    oldBrowser = true;
  }
  if (is.edge() && is.edge('<17')) {
    incompatible = true;
    oldBrowser = true;
  }
  if (is.opera() && is.opera('<66')) {
    incompatible = true;
    oldBrowser = true;
  }

  // WebGL?
  if (!checkWebGL()) {
    incompatible = true;
    noWebgl = true;
  }

  // Screen width?
  if (window.screen.width < 1200) {
    incompatible = true;
    screenWidthTooLow = true;
  }

  return {
    incompatible,
    mobile,
    ios,
    android,
    wrongBrowser,
    oldBrowser,
    noWebgl,
    screenWidthTooLow
  };
};

/**
 * Wrapper function that just returns if the environment is compatible or not. For more detailed information use createCompatibilityReport instead.
 * @returns {boolean} - True if the app is compatible with the environment, false if not.
 */
const compatibilityCheck = () => {
  const isResetPasswordPath = window.location.pathname === '/reset-password';
  const isSignupPath = window.location.pathname === '/signup';
  const isSetNewPasswordPath = window.location.pathname === '/set-new-password';
  const isMobileFriendlyPath = isResetPasswordPath || isSignupPath || isSetNewPasswordPath;
  const isCompatible = isMobileFriendlyPath || !createCompatibilityReport().incompatible;

  return isCompatible;
};

export default compatibilityCheck;
